export const mockListings = [
{
  id: '1',
  region: 'australia',
  properties: {
    address: '42 Harbour Street',
    suburb: 'Sydney',
    state: 'NSW',
    postcode: '2000',
    type: 'house',
    beds: 3,
    baths: 2,
    parking: 2
  },
  listing_type: 'buy',
  price_or_rent: 1850000,
  description_short: 'Stunning harbour views with modern finishes throughout',
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_15d655a5d-1772108899226.png", type: 'photo', alt: 'Modern Sydney house exterior with harbour views' },
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_11df829d5-1772108900447.png", type: 'photo', alt: 'Bright open-plan living room with harbour views' },
  { original_url: "https://images.unsplash.com/photo-1722764375583-146a5bc8d39c", type: 'photo', alt: 'Modern kitchen with stone benchtops and stainless appliances' },
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_1fbe90607-1772108900468.png", type: 'photo', alt: 'Master bedroom with ensuite and harbour views' },
  { original_url: "https://images.unsplash.com/photo-1664939404003-6ba1c2f4a31f", type: 'photo', alt: 'Outdoor entertaining deck overlooking Sydney Harbour' }]
},
{
  id: '2',
  region: 'australia',
  properties: {
    address: '156 Beach Road',
    suburb: 'Bondi Beach',
    state: 'NSW',
    postcode: '2026',
    type: 'unit',
    beds: 2,
    baths: 2,
    parking: 1
  },
  listing_type: 'buy',
  price_or_rent: 1250000,
  description_short: 'Beachside living at its finest with ocean glimpses',
  media: [
  { original_url: "https://images.unsplash.com/photo-1727156706995-74ec72711fc4", type: 'photo', alt: 'Bondi Beach apartment building exterior near the ocean' },
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_1f998bd74-1764661904247.png", type: 'photo', alt: 'Bright apartment living area with ocean glimpses' },
  { original_url: "https://images.unsplash.com/photo-1591924162725-63e2b23b78b6", type: 'photo', alt: 'Modern kitchen with white cabinetry and ocean views' },
  { original_url: "https://images.unsplash.com/photo-1651766263459-a70e9f1d2e92", type: 'photo', alt: 'Cozy bedroom with coastal decor and natural light' }]
},
{
  id: '3',
  region: 'australia',
  properties: {
    address: '88 Mountain View Drive',
    suburb: 'Melbourne',
    state: 'VIC',
    postcode: '3000',
    type: 'house',
    beds: 4,
    baths: 3,
    parking: 2
  },
  listing_type: 'buy',
  price_or_rent: 2100000,
  description_short: 'Spacious family home with panoramic city views',
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_1e52cd988-1772132425980.png", type: 'photo', alt: 'Spacious Melbourne family home exterior with double garage' },
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_1c3b4b3b3-1765899700970.png", type: 'photo', alt: 'Large open-plan family living and dining area' },
  { original_url: "https://images.unsplash.com/photo-1717429541792-5c59021d6ceb", type: 'photo', alt: 'Gourmet kitchen with island bench and city views' },
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_169d130cb-1764673105782.png", type: 'photo', alt: 'Master bedroom with walk-in wardrobe and ensuite' },
  { original_url: "https://images.unsplash.com/photo-1513334910040-0b9267213e4d", type: 'photo', alt: 'Landscaped backyard with alfresco entertaining area' }]
},
{
  id: '4',
  region: 'uae',
  properties: {
    address: 'Palm Jumeirah Villa 12',
    suburb: 'Palm Jumeirah',
    state: 'Dubai',
    postcode: '',
    type: 'villa',
    beds: 5,
    baths: 4,
    parking: 3
  },
  listing_type: 'buy',
  price_or_rent: 8500000,
  description_short: 'Luxury beachfront villa with private pool on Palm Jumeirah',
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_17f8115ee-1772110253296.png", type: 'photo', alt: 'Luxury Palm Jumeirah villa exterior with private pool and beach access' },
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_1a5ad0cda-1772153561176.png", type: 'photo', alt: 'Chef kitchen with marble countertops in luxury Dubai villa' }]
},
{
  id: '5',
  region: 'uae',
  properties: {
    address: 'Downtown Dubai Tower 45, Unit 2201',
    suburb: 'Downtown Dubai',
    state: 'Dubai',
    postcode: '',
    type: 'apartment',
    beds: 2,
    baths: 2,
    parking: 1
  },
  listing_type: 'buy',
  price_or_rent: 3200000,
  description_short: 'Stunning Burj Khalifa views from this modern high-rise apartment',
  media: [
  { original_url: "https://images.unsplash.com/photo-1733673764025-3dfeef09133c", type: 'photo', alt: 'Downtown Dubai high-rise apartment building with Burj Khalifa views' },
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_169be6201-1772109576210.png", type: 'photo', alt: 'Modern apartment living room with Burj Khalifa views' },
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_16d84f84b-1772109576229.png", type: 'photo', alt: 'Contemporary kitchen with high-end appliances in Downtown Dubai apartment' },
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_1b0f0b158-1772110248557.png", type: 'photo', alt: 'Elegant bedroom with city views in Downtown Dubai apartment' }]
},
{
  id: '6',
  region: 'uae',
  properties: {
    address: 'Yas Island Villa 8',
    suburb: 'Yas Island',
    state: 'Abu Dhabi',
    postcode: '',
    type: 'villa',
    beds: 4,
    baths: 3,
    parking: 2
  },
  listing_type: 'buy',
  price_or_rent: 5800000,
  description_short: 'Contemporary villa near Yas Marina Circuit with sea views',
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_1c0feadba-1769245567262.png", type: 'photo', alt: 'Contemporary Yas Island villa exterior with landscaped garden and sea views' },
  { original_url: "https://images.unsplash.com/photo-1555426104-3a03a4e70b1d", type: 'photo', alt: 'Private pool and outdoor terrace at Yas Island villa' }]
},
{
  id: '7',
  region: 'australia',
  properties: {
    address: '12 Collins Street',
    suburb: 'Melbourne',
    state: 'VIC',
    postcode: '3000',
    type: 'apartment',
    beds: 2,
    baths: 1,
    parking: 1
  },
  listing_type: 'rent',
  price_or_rent: 2800,
  description_short: 'Modern apartment in the heart of Melbourne CBD',
  media: [
  { original_url: "https://images.unsplash.com/photo-1700682274971-a0f29a99d8b9", type: 'photo', alt: 'Modern Melbourne CBD apartment building exterior on Collins Street' },
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_1e13741fb-1766566954518.png", type: 'photo', alt: 'Contemporary apartment living room with city views' }]
},
{
  id: '8',
  region: 'australia',
  properties: {
    address: '5 Riverside Walk',
    suburb: 'Brisbane',
    state: 'QLD',
    postcode: '4000',
    type: 'house',
    beds: 3,
    baths: 2,
    parking: 2
  },
  listing_type: 'rent',
  price_or_rent: 3200,
  description_short: 'Charming riverside home with large backyard and deck',
  media: [
  { original_url: "https://images.unsplash.com/photo-1513334910040-0b9267213e4d", type: 'photo', alt: 'Charming Brisbane riverside house with large deck and backyard' }]
},
{
  id: '9',
  region: 'uae',
  properties: {
    address: 'Marina Walk Apartment 1502',
    suburb: 'Dubai Marina',
    state: 'Dubai',
    postcode: '',
    type: 'apartment',
    beds: 1,
    baths: 1,
    parking: 1
  },
  listing_type: 'rent',
  price_or_rent: 85000,
  description_short: 'Stylish marina-view apartment in the vibrant Dubai Marina',
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_12d4ecc26-1772110246588.png", type: 'photo', alt: 'Dubai Marina apartment tower with marina and yacht views' },
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_1799da7ee-1772110247146.png", type: 'photo', alt: 'Stylish living room with marina views in Dubai Marina apartment' },
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_16d84f84b-1772109576229.png", type: 'photo', alt: 'Modern kitchen in Dubai Marina apartment with high-end finishes' }]
},
{
  id: '10',
  region: 'uae',
  properties: {
    address: 'JBR The Walk, Unit 304',
    suburb: 'Jumeirah Beach Residence',
    state: 'Dubai',
    postcode: '',
    type: 'apartment',
    beds: 2,
    baths: 2,
    parking: 1
  },
  listing_type: 'rent',
  price_or_rent: 120000,
  description_short: 'Beachfront apartment steps from the beach and dining',
  media: [
  { original_url: "https://images.unsplash.com/photo-1657579813217-777707525f94", type: 'photo', alt: 'JBR beachfront apartment building with beach and sea views' },
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_1ce695329-1772156479949.png", type: 'photo', alt: 'Modern kitchen in Jumeirah Beach Residence apartment' }]
},
// Dubai listings
{
  id: 'dxb-1',
  region: 'uae',
  emirate: 'Dubai',
  properties: {
    address: 'Palm Jumeirah Frond K, Villa 14',
    suburb: 'Palm Jumeirah',
    state: 'Dubai',
    postcode: '',
    type: 'villa',
    beds: 5,
    baths: 5,
    parking: 3
  },
  listing_type: 'buy',
  price_or_rent: 18500000,
  description_short: 'Iconic beachfront villa on Palm Jumeirah with private pool, direct beach access and panoramic Arabian Gulf views',
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_1f8add369-1771884478759.png", type: 'photo', alt: 'Iconic beachfront villa on Palm Jumeirah with private pool and Arabian Gulf views' },
  { original_url: "https://images.unsplash.com/photo-1566323526101-051f07ee8925", type: 'photo', alt: 'Private infinity pool with direct beach access at Palm Jumeirah villa' },
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_169be6201-1772109576210.png", type: 'photo', alt: 'Grand living room with panoramic Gulf views in Palm Jumeirah villa' },
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_161d80fa1-1772107528865.png", type: 'photo', alt: 'Luxury chef kitchen with marble island in Palm Jumeirah villa' },
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_10871d0ed-1764729353423.png", type: 'photo', alt: 'Master suite with sea views and walk-in closet in Palm Jumeirah villa' }]
},
{
  id: 'dxb-2',
  region: 'uae',
  emirate: 'Dubai',
  properties: {
    address: 'Burj Khalifa District, Tower 1, Unit 4802',
    suburb: 'Downtown Dubai',
    state: 'Dubai',
    postcode: '',
    type: 'apartment',
    beds: 3,
    baths: 3,
    parking: 2
  },
  listing_type: 'buy',
  price_or_rent: 7800000,
  description_short: 'Ultra-premium apartment with direct Burj Khalifa and Dubai Fountain views in the heart of Downtown Dubai',
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_1b0f0b158-1772110248557.png", type: 'photo', alt: 'Ultra-premium Downtown Dubai apartment with direct Burj Khalifa views' },
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_19b71a11d-1772110246421.png", type: 'photo', alt: 'Luxury living room with Burj Khalifa and Dubai Fountain views' },
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_17cc9c3a7-1772109575614.png", type: 'photo', alt: 'Premium kitchen with high-end appliances in Downtown Dubai apartment' },
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_1b0f0b158-1772110248557.png", type: 'photo', alt: 'Master bedroom with Burj Khalifa views in Downtown Dubai luxury apartment' }]
},
{
  id: 'dxb-3',
  region: 'uae',
  emirate: 'Dubai',
  properties: {
    address: 'Marina Gate Tower 2, Unit 1205',
    suburb: 'Dubai Marina',
    state: 'Dubai',
    postcode: '',
    type: 'apartment',
    beds: 2,
    baths: 2,
    parking: 1
  },
  listing_type: 'buy',
  price_or_rent: 3400000,
  description_short: 'Stylish marina-view apartment in Dubai Marina with world-class amenities and vibrant waterfront lifestyle',
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_12d4ecc26-1772110246588.png", type: 'photo', alt: 'Stylish Marina Gate Tower apartment in Dubai Marina with marina views' },
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_1f998bd74-1764661904247.png", type: 'photo', alt: 'Modern living room with marina views in Dubai Marina apartment' },
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_16d84f84b-1772109576229.png", type: 'photo', alt: 'Contemporary kitchen in Dubai Marina apartment' }]
},
{
  id: 'dxb-4',
  region: 'uae',
  emirate: 'Dubai',
  properties: {
    address: 'Jumeirah Village Circle, District 10, Villa 88',
    suburb: 'Jumeirah Village Circle',
    state: 'Dubai',
    postcode: '',
    type: 'villa',
    beds: 4,
    baths: 4,
    parking: 2
  },
  listing_type: 'buy',
  price_or_rent: 4200000,
  description_short: 'Modern independent villa in JVC with private garden, rooftop terrace and community park access',
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_1f8add369-1771884478759.png", type: 'photo', alt: 'Modern independent villa in Jumeirah Village Circle with private garden' },
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_1a95b1b63-1772110248653.png", type: 'photo', alt: 'Private garden and rooftop terrace at JVC villa Dubai' },
  { original_url: "https://images.unsplash.com/photo-1600122086257-9a6726dd274f", type: 'photo', alt: 'Spacious living room in Jumeirah Village Circle villa Dubai' }]
},
{
  id: 'dxb-5',
  region: 'uae',
  emirate: 'Dubai',
  properties: {
    address: 'Business Bay Executive Tower D, Unit 3301',
    suburb: 'Business Bay',
    state: 'Dubai',
    postcode: '',
    type: 'apartment',
    beds: 1,
    baths: 1,
    parking: 1
  },
  listing_type: 'rent',
  price_or_rent: 95000,
  description_short: 'Sleek studio-plus apartment in Business Bay with Dubai Canal views and direct metro access',
  media: [
  { original_url: "https://images.unsplash.com/photo-1502465107197-846f6fde18ac", type: 'photo', alt: 'Sleek Business Bay apartment tower with Dubai Canal views' },
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_1b6ac69c9-1769225421874.png", type: 'photo', alt: 'Modern studio apartment interior with canal views in Business Bay Dubai' }]
},
{
  id: 'dxb-7',
  region: 'uae',
  emirate: 'Dubai',
  properties: {
    address: 'Downtown Dubai, Burj Views Tower A, Unit 1102',
    suburb: 'Downtown Dubai',
    state: 'Dubai',
    postcode: '',
    type: 'apartment',
    beds: 2,
    baths: 2,
    parking: 1
  },
  listing_type: 'rent',
  price_or_rent: 145000,
  description_short: 'Stunning 2-bedroom apartment in Downtown Dubai with Burj Khalifa views, fully furnished and ready to move in',
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_1b0f0b158-1772110248557.png", type: 'photo', alt: 'Downtown Dubai apartment with Burj Khalifa views available for rent' },
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_19b71a11d-1772110246421.png", type: 'photo', alt: 'Bright living room with Burj Khalifa views in Downtown Dubai rental apartment' },
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_15cf3eb1d-1772109576216.png", type: 'photo', alt: 'Modern bedroom in Downtown Dubai rental apartment' },
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_1615f68dc-1770163383698.png", type: 'photo', alt: 'Contemporary kitchen in Downtown Dubai rental apartment' }]
},
{
  id: 'dxb-8',
  region: 'uae',
  emirate: 'Dubai',
  properties: {
    address: 'Palm Jumeirah, Shoreline Apartments, Block 12, Unit 504',
    suburb: 'Palm Jumeirah',
    state: 'Dubai',
    postcode: '',
    type: 'apartment',
    beds: 3,
    baths: 2,
    parking: 2
  },
  listing_type: 'rent',
  price_or_rent: 220000,
  description_short: 'Spacious 3-bedroom apartment on Palm Jumeirah with private beach access and sea views — perfect for families',
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_10871d0ed-1764729353423.png", type: 'photo', alt: 'Palm Jumeirah Shoreline apartment with private beach access and sea views for rent' },
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_10871d0ed-1764729353423.png", type: 'photo', alt: 'Spacious living room with sea views in Palm Jumeirah rental apartment' },
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_10871d0ed-1764729353423.png", type: 'photo', alt: 'Master bedroom with Arabian Gulf views in Palm Jumeirah apartment' },
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_1052f63c4-1766213438869.png", type: 'photo', alt: 'Modern kitchen in Palm Jumeirah Shoreline rental apartment' }]
},
{
  id: 'dxb-9',
  region: 'uae',
  emirate: 'Dubai',
  properties: {
    address: 'Dubai Marina, Marina Promenade, Unit 2203',
    suburb: 'Dubai Marina',
    state: 'Dubai',
    postcode: '',
    type: 'apartment',
    beds: 1,
    baths: 1,
    parking: 1
  },
  listing_type: 'rent',
  price_or_rent: 80000,
  description_short: 'Chic 1-bedroom apartment in Dubai Marina with full marina views, gym and pool — ideal for young professionals',
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_1cbd12076-1772109575907.png", type: 'photo', alt: 'Dubai Marina apartment tower with marina views available for rent' },
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_1799da7ee-1772110247146.png", type: 'photo', alt: 'Modern living room with marina views in Dubai Marina rental apartment' },
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_16d84f84b-1772109576229.png", type: 'photo', alt: 'Stylish kitchen in Dubai Marina rental apartment' }]
},
{
  id: 'dxb-10',
  region: 'uae',
  emirate: 'Dubai',
  properties: {
    address: 'Jumeirah Village Circle, District 15, Apartment 301',
    suburb: 'Jumeirah Village Circle',
    state: 'Dubai',
    postcode: '',
    type: 'apartment',
    beds: 2,
    baths: 2,
    parking: 1
  },
  listing_type: 'rent',
  price_or_rent: 75000,
  description_short: 'Affordable 2-bedroom apartment in JVC with community park views — great value in a family-friendly neighbourhood',
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_15d202032-1772109576221.png", type: 'photo', alt: 'Affordable 2-bedroom apartment in Jumeirah Village Circle Dubai for rent' },
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_1fa67c22f-1772109577302.png", type: 'photo', alt: 'Bright living room in JVC rental apartment Dubai' },
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_197e71cba-1772109575845.png", type: 'photo', alt: 'Modern kitchen in Jumeirah Village Circle rental apartment Dubai' }]
},
// Abu Dhabi listings
{
  id: 'auh-1',
  region: 'uae',
  emirate: 'Abu Dhabi',
  properties: {
    address: 'Saadiyat Island, Mamsha Al Saadiyat, Villa 7',
    suburb: 'Saadiyat Island',
    state: 'Abu Dhabi',
    postcode: '',
    type: 'villa',
    beds: 5,
    baths: 5,
    parking: 3
  },
  listing_type: 'buy',
  price_or_rent: 14500000,
  description_short: 'Beachfront villa on Saadiyat Island near the Louvre Abu Dhabi with private beach and cultural district access',
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_1c370c8a2-1772156406303.png", type: 'photo', alt: 'Beachfront villa on Saadiyat Island Abu Dhabi near Louvre with private beach' },
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_17f8115ee-1772110253296.png", type: 'photo', alt: 'Private beach and pool at Saadiyat Island villa Abu Dhabi' }]
},
{
  id: 'auh-2',
  region: 'uae',
  emirate: 'Abu Dhabi',
  properties: {
    address: 'Al Reem Island, Shams Abu Dhabi, Tower C, Unit 1802',
    suburb: 'Al Reem Island',
    state: 'Abu Dhabi',
    postcode: '',
    type: 'apartment',
    beds: 3,
    baths: 2,
    parking: 2
  },
  listing_type: 'buy',
  price_or_rent: 5200000,
  description_short: 'Spacious apartment on Al Reem Island with sea views, close to Abu Dhabi CBD and world-class amenities',
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_10871d0ed-1764729353423.png", type: 'photo', alt: 'Spacious apartment tower on Al Reem Island Abu Dhabi with sea views' },
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_1241f1af3-1766163578033.png", type: 'photo', alt: 'Bright living room with sea views in Al Reem Island apartment Abu Dhabi' }]
},
{
  id: 'auh-3',
  region: 'uae',
  emirate: 'Abu Dhabi',
  properties: {
    address: 'Yas Island, Yas Acres, Plot 45',
    suburb: 'Yas Island',
    state: 'Abu Dhabi',
    postcode: '',
    type: 'villa',
    beds: 4,
    baths: 4,
    parking: 2
  },
  listing_type: 'buy',
  price_or_rent: 6800000,
  description_short: 'Contemporary villa in Yas Acres with golf course views, minutes from Yas Marina Circuit and Ferrari World',
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_14ca36ff0-1767536422886.png", type: 'photo', alt: 'Contemporary villa in Yas Acres Abu Dhabi with golf course views' }]
},
{
  id: 'auh-4',
  region: 'uae',
  emirate: 'Abu Dhabi',
  properties: {
    address: 'Corniche Road, Etihad Towers, Tower 3, Unit 2501',
    suburb: 'Corniche',
    state: 'Abu Dhabi',
    postcode: '',
    type: 'apartment',
    beds: 2,
    baths: 2,
    parking: 1
  },
  listing_type: 'rent',
  price_or_rent: 130000,
  description_short: 'Prestigious Etihad Towers apartment on Abu Dhabi Corniche with stunning Arabian Gulf views and 5-star hotel services',
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_10871d0ed-1764729353423.png", type: 'photo', alt: 'Prestigious Etihad Towers apartment on Abu Dhabi Corniche with Arabian Gulf views' }]
},
{
  id: 'auh-5',
  region: 'uae',
  emirate: 'Abu Dhabi',
  properties: {
    address: 'Al Maryah Island, Galleria Residences, Unit 1104',
    suburb: 'Al Maryah Island',
    state: 'Abu Dhabi',
    postcode: '',
    type: 'apartment',
    beds: 1,
    baths: 1,
    parking: 1
  },
  listing_type: 'rent',
  price_or_rent: 85000,
  description_short: 'Modern apartment on Al Maryah Island — Abu Dhabi\'s financial hub — with Galleria Mall access and waterfront promenade',
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_172df5bfa-1767818371345.png", type: 'photo', alt: 'Modern apartment on Al Maryah Island Abu Dhabi near Galleria Mall' }]
},
// Sharjah listings
{
  id: 'shj-1',
  region: 'uae',
  emirate: 'Sharjah',
  properties: {
    address: 'Al Majaz Waterfront, Tower 5, Unit 802',
    suburb: 'Al Majaz',
    state: 'Sharjah',
    postcode: '',
    type: 'apartment',
    beds: 3,
    baths: 2,
    parking: 1
  },
  listing_type: 'buy',
  price_or_rent: 1450000,
  description_short: 'Spacious apartment on Al Majaz Waterfront with Khalid Lagoon views and walking distance to Sharjah Art Museum',
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_1799da7ee-1772110247146.png", type: 'photo', alt: 'Spacious apartment on Al Majaz Waterfront Sharjah with Khalid Lagoon views' }]
},
{
  id: 'shj-2',
  region: 'uae',
  emirate: 'Sharjah',
  properties: {
    address: 'Aljada Community, Madar District, Villa 22',
    suburb: 'Aljada',
    state: 'Sharjah',
    postcode: '',
    type: 'villa',
    beds: 4,
    baths: 3,
    parking: 2
  },
  listing_type: 'buy',
  price_or_rent: 2200000,
  description_short: 'Family villa in Aljada — Sharjah\'s largest mixed-use development — with community park, retail and entertainment hub',
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_1188f28dd-1772108459855.png", type: 'photo', alt: 'Family villa in Aljada Sharjah largest mixed-use development with community park' }]
},
{
  id: 'shj-3',
  region: 'uae',
  emirate: 'Sharjah',
  properties: {
    address: 'Muwaileh Commercial, Al Zahia, Unit 305',
    suburb: 'Muwaileh',
    state: 'Sharjah',
    postcode: '',
    type: 'apartment',
    beds: 2,
    baths: 2,
    parking: 1
  },
  listing_type: 'rent',
  price_or_rent: 42000,
  description_short: 'Affordable modern apartment in Muwaileh near University City — ideal for families and professionals commuting to Dubai',
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_123726ee3-1772156406473.png", type: 'photo', alt: 'Affordable modern apartment in Muwaileh Sharjah near University City' }]
},
{
  id: 'shj-4',
  region: 'uae',
  emirate: 'Sharjah',
  properties: {
    address: 'Tilal City, Phase 2, Plot 88',
    suburb: 'Tilal City',
    state: 'Sharjah',
    postcode: '',
    type: 'villa',
    beds: 5,
    baths: 4,
    parking: 3
  },
  listing_type: 'buy',
  price_or_rent: 3100000,
  description_short: 'Generous plot villa in Tilal City with freehold ownership — Sharjah\'s first freehold community for all nationalities',
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_1188f28dd-1772108459855.png", type: 'photo', alt: 'Generous villa in Tilal City Sharjah first freehold community for all nationalities' }]
},
// Ajman listings
{
  id: 'ajm-1',
  region: 'uae',
  emirate: 'Ajman',
  properties: {
    address: 'Ajman Corniche Road, Al Khor Tower, Unit 604',
    suburb: 'Ajman Corniche',
    state: 'Ajman',
    postcode: '',
    type: 'apartment',
    beds: 2,
    baths: 2,
    parking: 1
  },
  listing_type: 'buy',
  price_or_rent: 680000,
  description_short: 'Affordable sea-view apartment on Ajman Corniche — excellent rental yield potential with growing expat demand',
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_10871d0ed-1764729353423.png", type: 'photo', alt: 'Affordable sea-view apartment on Ajman Corniche with excellent rental yield' }]
},
{
  id: 'ajm-2',
  region: 'uae',
  emirate: 'Ajman',
  properties: {
    address: 'Emirates City, Lavender Tower, Unit 1201',
    suburb: 'Emirates City',
    state: 'Ajman',
    postcode: '',
    type: 'apartment',
    beds: 1,
    baths: 1,
    parking: 1
  },
  listing_type: 'buy',
  price_or_rent: 380000,
  description_short: 'Budget-friendly apartment in Emirates City — one of the UAE\'s most affordable freehold communities with high ROI',
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_14c66c039-1764743881937.png", type: 'photo', alt: 'Budget-friendly apartment in Emirates City Ajman affordable freehold community' }]
},
{
  id: 'ajm-3',
  region: 'uae',
  emirate: 'Ajman',
  properties: {
    address: 'Al Hamidiyah, Garden City Villa 15',
    suburb: 'Al Hamidiyah',
    state: 'Ajman',
    postcode: '',
    type: 'villa',
    beds: 4,
    baths: 3,
    parking: 2
  },
  listing_type: 'buy',
  price_or_rent: 1200000,
  description_short: 'Spacious family villa in Al Hamidiyah with large garden — Ajman\'s most sought-after residential neighbourhood',
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_165af46a5-1765097003513.png", type: 'photo', alt: 'Spacious family villa in Al Hamidiyah Ajman with large garden' }]
},
{
  id: 'ajm-4',
  region: 'uae',
  emirate: 'Ajman',
  properties: {
    address: 'Al Nuaimiya, Tower 3, Unit 502',
    suburb: 'Al Nuaimiya',
    state: 'Ajman',
    postcode: '',
    type: 'apartment',
    beds: 2,
    baths: 1,
    parking: 1
  },
  listing_type: 'rent',
  price_or_rent: 28000,
  description_short: 'Well-maintained apartment in Al Nuaimiya — Ajman\'s commercial hub — with easy access to Sharjah and Dubai highways',
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_10871d0ed-1764729353423.png", type: 'photo', alt: 'Well-maintained apartment in Al Nuaimiya Ajman near Sharjah and Dubai highways' }]
},
// Ras Al Khaimah listings
{
  id: 'rak-1',
  region: 'uae',
  emirate: 'Ras Al Khaimah',
  properties: {
    address: 'Al Marjan Island, Bab Al Bahr, Villa 12',
    suburb: 'Al Marjan Island',
    state: 'Ras Al Khaimah',
    postcode: '',
    type: 'villa',
    beds: 4,
    baths: 4,
    parking: 2
  },
  listing_type: 'buy',
  price_or_rent: 4500000,
  description_short: 'Stunning resort villa on Al Marjan Island — RAK\'s premier destination — near the upcoming Wynn Casino resort',
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_118c870d0-1772108460576.png", type: 'photo', alt: 'Stunning resort villa on Al Marjan Island Ras Al Khaimah near Wynn Casino resort' }]
},
{
  id: 'rak-2',
  region: 'uae',
  emirate: 'Ras Al Khaimah',
  properties: {
    address: 'Mina Al Arab, Flamingo Villas, Unit 8',
    suburb: 'Mina Al Arab',
    state: 'Ras Al Khaimah',
    postcode: '',
    type: 'villa',
    beds: 3,
    baths: 3,
    parking: 2
  },
  listing_type: 'buy',
  price_or_rent: 2800000,
  description_short: 'Waterfront villa in Mina Al Arab with mangrove views, private beach access and eco-resort lifestyle',
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_17f8115ee-1772110253296.png", type: 'photo', alt: 'Waterfront villa in Mina Al Arab Ras Al Khaimah with mangrove views and private beach' }]
},
{
  id: 'rak-3',
  region: 'uae',
  emirate: 'Ras Al Khaimah',
  properties: {
    address: 'RAK City Centre, Al Nakheel, Tower B, Unit 905',
    suburb: 'Al Nakheel',
    state: 'Ras Al Khaimah',
    postcode: '',
    type: 'apartment',
    beds: 2,
    baths: 2,
    parking: 1
  },
  listing_type: 'buy',
  price_or_rent: 950000,
  description_short: 'Modern apartment in RAK City Centre with Hajar Mountain backdrop — affordable entry into a fast-growing tourism market',
  media: [
  { original_url: "https://images.unsplash.com/photo-1578725763208-0923c930cd53", type: 'photo', alt: 'Modern apartment in Ras Al Khaimah City Centre with Hajar Mountain backdrop' }]
},
{
  id: 'rak-4',
  region: 'uae',
  emirate: 'Ras Al Khaimah',
  properties: {
    address: 'Hayat Island, Anantara Residences, Unit 601',
    suburb: 'Hayat Island',
    state: 'Ras Al Khaimah',
    postcode: '',
    type: 'apartment',
    beds: 1,
    baths: 1,
    parking: 1
  },
  listing_type: 'rent',
  price_or_rent: 65000,
  description_short: 'Luxury serviced apartment on Hayat Island with Anantara resort amenities, beach access and stunning sea views',
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_1f8aa885b-1765192413094.png", type: 'photo', alt: 'Luxury serviced apartment on Hayat Island Ras Al Khaimah with Anantara resort amenities' }]
},
// Fujairah listings
{
  id: 'fjr-1',
  region: 'uae',
  emirate: 'Fujairah',
  properties: {
    address: 'Fujairah Corniche, Al Dana Tower, Unit 702',
    suburb: 'Fujairah Corniche',
    state: 'Fujairah',
    postcode: '',
    type: 'apartment',
    beds: 3,
    baths: 2,
    parking: 1
  },
  listing_type: 'buy',
  price_or_rent: 1100000,
  description_short: 'East coast apartment on Fujairah Corniche with Indian Ocean views — unique opportunity in UAE\'s only east-coast emirate',
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_10871d0ed-1764729353423.png", type: 'photo', alt: 'East coast apartment on Fujairah Corniche with Indian Ocean views' }]
},
{
  id: 'fjr-2',
  region: 'uae',
  emirate: 'Fujairah',
  properties: {
    address: 'Dibba Al Fujairah, Mountain View Villas, Villa 5',
    suburb: 'Dibba Al Fujairah',
    state: 'Fujairah',
    postcode: '',
    type: 'villa',
    beds: 4,
    baths: 3,
    parking: 2
  },
  listing_type: 'buy',
  price_or_rent: 1850000,
  description_short: 'Scenic villa in Dibba with Hajar Mountain views and proximity to world-class diving sites and Musandam border',
  media: [
  { original_url: "https://images.unsplash.com/photo-1621412524294-d5608a29160e", type: 'photo', alt: 'Scenic villa in Dibba Al Fujairah with Hajar Mountain views near diving sites' }]
},
{
  id: 'fjr-3',
  region: 'uae',
  emirate: 'Fujairah',
  properties: {
    address: 'Fujairah City, Al Faseel Road, Unit 204',
    suburb: 'Al Faseel',
    state: 'Fujairah',
    postcode: '',
    type: 'apartment',
    beds: 2,
    baths: 1,
    parking: 1
  },
  listing_type: 'rent',
  price_or_rent: 35000,
  description_short: 'Peaceful apartment in Fujairah City — tranquil east coast living with mountain scenery and uncrowded beaches nearby',
  media: [
  { original_url: "https://images.unsplash.com/photo-1724404461355-83783d132b3d", type: 'photo', alt: 'Peaceful apartment in Fujairah City with mountain scenery and beaches nearby' }]
},
// Umm Al Quwain listings
{
  id: 'uaq-1',
  region: 'uae',
  emirate: 'Umm Al Quwain',
  properties: {
    address: 'UAQ Marina, Dreamland Residences, Villa 3',
    suburb: 'UAQ Marina',
    state: 'Umm Al Quwain',
    postcode: '',
    type: 'villa',
    beds: 3,
    baths: 3,
    parking: 2
  },
  listing_type: 'buy',
  price_or_rent: 1600000,
  description_short: 'Waterfront villa in UAQ Marina — UAE\'s most affordable emirate with untouched coastline and serene lagoon lifestyle',
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_16558e1ef-1764793853208.png", type: 'photo', alt: 'Waterfront villa in UAQ Marina Umm Al Quwain with untouched coastline and lagoon views' }]
},
{
  id: 'uaq-2',
  region: 'uae',
  emirate: 'Umm Al Quwain',
  properties: {
    address: 'Al Salamah, Corniche Tower, Unit 405',
    suburb: 'Al Salamah',
    state: 'Umm Al Quwain',
    postcode: '',
    type: 'apartment',
    beds: 2,
    baths: 2,
    parking: 1
  },
  listing_type: 'buy',
  price_or_rent: 520000,
  description_short: 'Affordable sea-view apartment in UAQ — lowest entry price in the UAE with strong capital appreciation potential',
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_10871d0ed-1764729353423.png", type: 'photo', alt: 'Affordable sea-view apartment in Umm Al Quwain with strong capital appreciation' }]
},
{
  id: 'uaq-3',
  region: 'uae',
  emirate: 'Umm Al Quwain',
  properties: {
    address: 'UAQ Free Trade Zone, Warehouse Block C, Unit 8',
    suburb: 'UAQ Free Trade Zone',
    state: 'Umm Al Quwain',
    postcode: '',
    type: 'warehouse',
    beds: 0,
    baths: 1,
    parking: 8
  },
  listing_type: 'commercial',
  price_or_rent: 850000,
  description_short: 'Low-cost commercial warehouse in UAQ Free Trade Zone — ideal for SMEs seeking affordable UAE base with 100% foreign ownership',
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_18d15918e-1772108461685.png", type: 'photo', alt: 'Commercial warehouse in UAQ Free Trade Zone with 100% foreign ownership for SMEs' }]
},
{
  id: 'uaq-4',
  region: 'uae',
  emirate: 'Umm Al Quwain',
  properties: {
    address: 'Falaj Al Mualla, Al Raudah Villa 18',
    suburb: 'Falaj Al Mualla',
    state: 'Umm Al Quwain',
    postcode: '',
    type: 'villa',
    beds: 4,
    baths: 3,
    parking: 2
  },
  listing_type: 'rent',
  price_or_rent: 38000,
  description_short: 'Spacious family villa in Falaj Al Mualla — quiet residential area with large plot, ideal for families seeking space at low cost',
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_17518d375-1772156406306.png", type: 'photo', alt: 'Spacious family villa in Falaj Al Mualla Umm Al Quwain with large plot' }]
},
// ── BANGLADESH LISTINGS ──
{
  id: 'bd-1',
  region: 'bangladesh',
  properties: {
    address: 'House 12, Road 5, Block C',
    suburb: 'Gulshan',
    state: 'Dhaka',
    postcode: '1212',
    type: 'apartment',
    beds: 3,
    baths: 3,
    parking: 1
  },
  listing_type: 'buy',
  price_or_rent: 9500000,
  currency: 'BDT',
  description_short: 'Premium 3-bed apartment in Gulshan 2 — diplomatic zone, 24/7 security, rooftop pool, RAJUK approved building',
  media: [
  { original_url: "https://images.unsplash.com/photo-1613232218235-06b473107ca9", type: 'photo', alt: 'Modern apartment building exterior in Gulshan Dhaka with glass facade' },
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_1ff3cba3a-1772306283767.png", type: 'photo', alt: 'Spacious living room with modern furnishings in Gulshan apartment' }]
},
{
  id: 'bd-2',
  region: 'bangladesh',
  properties: {
    address: 'Flat 8B, Banani DOHS',
    suburb: 'Banani',
    state: 'Dhaka',
    postcode: '1213',
    type: 'apartment',
    beds: 4,
    baths: 4,
    parking: 2
  },
  listing_type: 'buy',
  price_or_rent: 15000000,
  currency: 'BDT',
  description_short: 'Luxury 4-bed penthouse in Banani DOHS — army-managed secure zone, lake views, imported fittings, 2 car parking',
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_143e99ffe-1772130768410.png", type: 'photo', alt: 'Luxury penthouse apartment exterior in Banani DOHS Dhaka with lake views' },
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_1337d909d-1767678381064.png", type: 'photo', alt: 'Open-plan luxury living area with floor-to-ceiling windows and city views' }]
},
{
  id: 'bd-3',
  region: 'bangladesh',
  properties: {
    address: 'Road 27, Dhanmondi R/A',
    suburb: 'Dhanmondi',
    state: 'Dhaka',
    postcode: '1209',
    type: 'apartment',
    beds: 3,
    baths: 2,
    parking: 1
  },
  listing_type: 'rent',
  price_or_rent: 45000,
  currency: 'BDT',
  description_short: 'Well-maintained 3-bed flat in Dhanmondi — near Rabindra Sarobar lake, schools, hospitals. Ideal for families.',
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_15a3ed569-1773897668257.png", type: 'photo', alt: 'Residential apartment building in Dhanmondi Dhaka near lake' },
  { original_url: "https://images.unsplash.com/photo-1721825174200-a7a8366189a5", type: 'photo', alt: 'Bright kitchen and dining area in Dhanmondi apartment' }]
},
{
  id: 'bd-4',
  region: 'bangladesh',
  properties: {
    address: 'Sector 7, Uttara Model Town',
    suburb: 'Uttara',
    state: 'Dhaka',
    postcode: '1230',
    type: 'house',
    beds: 5,
    baths: 4,
    parking: 2
  },
  listing_type: 'buy',
  price_or_rent: 22000000,
  currency: 'BDT',
  description_short: 'Spacious 5-bed independent house in Uttara Sector 7 — RAJUK planned township, near Hazrat Shahjalal Airport, excellent connectivity',
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_1018c702d-1773897668251.png", type: 'photo', alt: 'Independent family house in Uttara Dhaka with garden and driveway' },
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_15e49f59b-1773897664369.png", type: 'photo', alt: 'Spacious living room in Uttara house with modern interior design' }]
},
{
  id: 'bd-5',
  region: 'bangladesh',
  properties: {
    address: 'Agrabad Commercial Area, Plot 45',
    suburb: 'Agrabad',
    state: 'Chittagong',
    postcode: '4100',
    type: 'apartment',
    beds: 3,
    baths: 2,
    parking: 1
  },
  listing_type: 'buy',
  price_or_rent: 7500000,
  currency: 'BDT',
  description_short: 'Modern 3-bed apartment in Agrabad — Chittagong\'s prime commercial hub, port city views, strong rental yield potential',
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_1d59e56b6-1772403306341.png", type: 'photo', alt: 'Modern apartment in Agrabad Chittagong with port city views' }]
},
{
  id: 'bd-6',
  region: 'bangladesh',
  properties: {
    address: 'Nasirabad Housing Society, Block B',
    suburb: 'Nasirabad',
    state: 'Chittagong',
    postcode: '4210',
    type: 'apartment',
    beds: 2,
    baths: 2,
    parking: 1
  },
  listing_type: 'rent',
  price_or_rent: 25000,
  currency: 'BDT',
  description_short: 'Comfortable 2-bed flat in Nasirabad Housing Society — gated community, generator backup, near GEC Circle and shopping malls',
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_19dfc23bb-1773897665750.png", type: 'photo', alt: 'Comfortable apartment in Nasirabad Housing Society Chittagong gated community' }]
},
{
  id: 'bd-7',
  region: 'bangladesh',
  properties: {
    address: 'Amberkhana, Sylhet City',
    suburb: 'Amberkhana',
    state: 'Sylhet',
    postcode: '3100',
    type: 'apartment',
    beds: 4,
    baths: 3,
    parking: 2
  },
  listing_type: 'buy',
  price_or_rent: 8500000,
  currency: 'BDT',
  description_short: 'NRB-favourite 4-bed apartment in Amberkhana Sylhet — UK/US diaspora investment hotspot, modern finishes, near Osmani Airport',
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_1714e929a-1773897666703.png", type: 'photo', alt: 'Modern apartment building in Amberkhana Sylhet popular with NRB diaspora' }]
},
{
  id: 'bd-8',
  region: 'bangladesh',
  properties: {
    address: 'Shahjalal Upashahar, Block D',
    suburb: 'Shahjalal Upashahar',
    state: 'Sylhet',
    postcode: '3100',
    type: 'house',
    beds: 5,
    baths: 3,
    parking: 3
  },
  listing_type: 'buy',
  price_or_rent: 18000000,
  currency: 'BDT',
  description_short: 'Premium villa in Shahjalal Upashahar — Sylhet\'s most prestigious address, landscaped garden, imported tiles, NRB community',
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_16e2d3689-1773897667898.png", type: 'photo', alt: 'Premium villa in Shahjalal Upashahar Sylhet with landscaped garden' }]
},
{
  id: 'bd-9',
  region: 'bangladesh',
  properties: {
    address: 'Kolatoli Beach Road, Plot 22',
    suburb: 'Kolatoli',
    state: "Cox\'s Bazar",
    postcode: '4700',
    type: 'apartment',
    beds: 2,
    baths: 2,
    parking: 1
  },
  listing_type: 'buy',
  price_or_rent: 6500000,
  currency: 'BDT',
  description_short: "Sea-view apartment on Cox\'s Bazar Kolatoli Beach Road — world's longest beach, high short-term rental ROI, tourist zone",
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_192a7df72-1773052129727.png", type: 'photo', alt: "Sea-view apartment building on Cox\'s Bazar beach road with ocean views" }]
},
{
  id: 'bd-10',
  region: 'bangladesh',
  properties: {
    address: 'Marine Drive, Inani Beach',
    suburb: 'Inani',
    state: "Cox's Bazar",
    postcode: '4701',
    type: 'house',
    beds: 4,
    baths: 3,
    parking: 2
  },
  listing_type: 'buy',
  price_or_rent: 12000000,
  currency: 'BDT',
  description_short: "Beachfront resort villa on Marine Drive Inani — private beach access, investment property, strong Airbnb/tourism rental income",
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_171b5f372-1773897670974.png", type: 'photo', alt: "Beachfront resort villa on Inani Beach Cox\'s Bazar with private beach access" }]
},
{
  id: 'bd-11',
  region: 'bangladesh',
  properties: {
    address: 'Bashundhara R/A, Block J',
    suburb: 'Bashundhara',
    state: 'Dhaka',
    postcode: '1229',
    type: 'apartment',
    beds: 3,
    baths: 3,
    parking: 1
  },
  listing_type: 'buy',
  price_or_rent: 11000000,
  currency: 'BDT',
  description_short: 'Modern 3-bed in Bashundhara Residential Area — RAJUK approved, near International University, shopping malls, and expressway',
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_14ce091b5-1773897668697.png", type: 'photo', alt: 'Modern apartment complex in Bashundhara Residential Area Dhaka near university' }]
},
{
  id: 'bd-12',
  region: 'bangladesh',
  properties: {
    address: 'Purbachal New Town, Sector 12',
    suburb: 'Purbachal',
    state: 'Dhaka',
    postcode: '1461',
    type: 'house',
    beds: 4,
    baths: 3,
    parking: 2
  },
  listing_type: 'buy',
  price_or_rent: 16500000,
  currency: 'BDT',
  description_short: 'RAJUK Purbachal New Town plot — government-planned satellite city, 300-ft expressway access, future metro connectivity',
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_1aecdee68-1773897665335.png", type: 'photo', alt: 'New residential development in Purbachal New Town RAJUK planned satellite city Dhaka' }]
},
{
  id: 'bd-13',
  region: 'bangladesh',
  properties: {
    address: 'Agrabad, Chittagong Commercial Zone',
    suburb: 'Agrabad',
    state: 'Chittagong',
    postcode: '4100',
    type: 'office',
    beds: 0,
    baths: 2,
    parking: 4
  },
  listing_type: 'commercial',
  price_or_rent: 3500000,
  currency: 'BDT',
  description_short: 'Prime commercial office space in Agrabad — Chittagong port city business hub, 2,400 sqft, ideal for corporate HQ or trading company',
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_101ea3091-1773897665213.png", type: 'photo', alt: 'Commercial office space in Agrabad Chittagong business district with modern interior' }]
},
{
  id: 'bd-14',
  region: 'bangladesh',
  properties: {
    address: 'Gulshan Avenue, Commercial Tower',
    suburb: 'Gulshan',
    state: 'Dhaka',
    postcode: '1212',
    type: 'office',
    beds: 0,
    baths: 3,
    parking: 6
  },
  listing_type: 'commercial',
  price_or_rent: 8000000,
  currency: 'BDT',
  description_short: 'Grade-A commercial floor in Gulshan Avenue tower — Dhaka\'s diplomatic and business district, 4,000 sqft, RAJUK compliant',
  media: [
  { original_url: "https://img.rocket.new/generatedImages/rocket_gen_img_1a8d6a08b-1773897664670.png", type: 'photo', alt: 'Grade-A commercial office tower in Gulshan Avenue Dhaka diplomatic business district' }]
}];